;(function() {
  'use strict'

  Provider.$inject = ["$stateProvider"];
  angular.module('app.error').provider('glError', Provider)

  /* @ngInject */
  function Provider($stateProvider) {
    Service.$inject = ["$transitions", "$rootScope", "$log", "$state", "configService", "AUTH_EVENTS"];
    var Routes = {
      DEFAULT: 'gl-error',
    }

    var Types = {
      MAINTENANCE: 'MAINTENANCE',
      INTERNAL: 'INTERNAL',
      NOTFOUND: 'NOTFOUND',
      UNAUTHORIZED: 'UNAUTHORIZED',
    }
    var DEFAULT_TYPE = Types.NOTFOUND

    this.setRoutes = setRoutes
    this.$get = Service

    /**
     * Set Route
     *
     * @desc Set cusom routes to error messages. Useful if you want to display an error in a sub-state
     * @example
     * // sets the default route to the substate that contains the header/footer
     * glErrorProvider.setRoutes({ DEFAULT: 'app.portal.error' });
     */
    function setRoutes(routes) {
      Routes = routes
    }

    function Service(
      $transitions,
      $rootScope,
      $log,
      $state,
      configService,
      AUTH_EVENTS
    ) {
      var log = $log.create('glError')
      var currentError

      // require a default route
      if (!Routes.DEFAULT) {
        return log.error('Routes.DEFAULT can be overwritten but NOT removed.')
      }

      var defaultTypeOptions = [
        {
          type: Types.MAINTENANCE,
          route: Routes.DEFAULT,
          icon: 'gi gi-disconnected',
          title: 'Site Maintenance',
          message: "Service is temporarily unavailable. We'll be back soon!",
        },
        {
          type: Types.INTERNAL,
          route: Routes.DEFAULT,
          icon: 'gi gi-mood-4',
          title: 'Sorry',
          message: 'Looks like something went wrong on our end.',
        },
        {
          type: Types.NOTFOUND,
          route: Routes.DEFAULT,
          icon: 'gi gi-important',
          title: 'Not Found',
          message: "We couldn't find that! It may no longer be available.",
          // link: {
          //   text: 'Learn more about Glow',
          //   url: configService.getUserPortalUrl('/public'),
          // },
        },
        {
          type: Types.UNAUTHORIZED,
          route: Routes.DEFAULT,
          icon: 'gi gi-unregistered',
          title: 'Unauthorized',
          message:
            "You don't have access to this. Please sign-in or change user to continue",
        },
      ]

      console.log(configService.getUserPortalUrl('/public'))

      $transitions.onStart(null, onStateChangeStart)
      $rootScope.$on(AUTH_EVENTS.loginSuccess, onLogin)

      createRoutes()

      return {
        unauthorized: unauthorized,
        notFound: notFound,
        internal: internal,
        fromStatus: fromStatus,
        get: get,
        Types: Types,
        Routes: Routes,
      }

      function createRoutes() {
        // generate error states based on config etc
        _.each(Routes, function(route) {
          $stateProvider.state(route, {
            url: '/error',
            controller: 'Error',
            controllerAs: '$ctrl',
            templateUrl: 'error.html',
          })
        })
      }

      function onLogin() {
        var isUnauthorized =
          currentError && currentError.type === Types.UNAUTHORIZED
        var onErrorPage = _.includes(Routes, $state.current.name)

        // if a user logs in and they were on an error page - automatically reload the state again
        if (isUnauthorized && onErrorPage) {
          $state.go(currentError.stateName, currentError.stateParams, {
            location: false,
          })
        }
      }

      /**
       * Unauthorized Error
       *
       * @desc Display an unauthorized error. Unauthorized errors will automatically refresh after login and
       *       broadcast an event for error logging etc.
       * @param {Object} options The options that will override the defaults (optional)
       * @example
       * // displays an unauthorized error
       * glError.unauthorized();
       * // display an unauthorized error with custom message
       * glError.unauthorized({ message: 'You dont have permission, bro! '});
       */
      function unauthorized(options) {
        options = options || {}
        options.type = Types.UNAUTHORIZED
        displayError(options)
      }

      /**
       * NotFound Error
       *
       * @desc Display a not-found error. Not-found errors broadcast an event for error logging etc.
       * @param {Object} options The options that will override the defaults (optional)
       * @example
       * // displays a not-found error
       * glError.notFound();
       * // display a not-found error with custom title
       * glError.unauthorized({ title: 'Survey Finished' });
       */
      function notFound(options) {
        options = options || {}
        options.type = Types.NOTFOUND
        displayError(options)
      }

      /**
             * Internal Error
             *
             * @desc Display an internal error. Internal errors let the user know something is wrong at our end. Also
                     broadcasts an event for error logging.
             * @param {Object} options The options that will override the defaults (optional)
             * @example
             * // displays an internal error
             * glError.internal();
             * // display an internal error with custom route set up using the provider
             * glError.internal({ route: glError.Routes.BASE });
             */
      function internal(options) {
        options = options || {}
        options.type = Types.INTERNAL
        displayError(options)
      }

      /**
             * Maintenance Error
             *
             * @desc Display a maintenance error. Lets the user know to try again later. Also broadcasts an event
                     for error logging.
             * @param {Object} options The options that will override the defaults (optional)
             * @example
             * // displays a maintenance error
             * glError.maintenance();
             * // display a maintenance error with custom route set up using the provider
             * glError.maintenance({ route: glError.Routes.BASE });
             */
      function maintenance(options) {
        options = options || {}
        options.type = Types.MAINTENANCE
        displayError(options)
      }

      /**
       * FromStatus Error
       *
       * @desc Displays the correct error based on the status passed as an argument
       * @param {String|Object} status An object with key 'status' or a Number
       * @example
       * // shorthand error pages using promises:
       * // as long as the promise rejection contains a status, it will resolve as an error page
       * getElement().then(null, glError.fromStatus);
       */
      function fromStatus(status) {
        status = _.isObject(status) ? status.status : status
        var errorFn
        switch (status) {
          case 503:
            errorFn = maintenance
            break
          case 500:
            errorFn = internal
            break
          case 401:
            errorFn = unauthorized
            break
          default:
            errorFn = notFound
        }
        errorFn()
      }

      function displayError(options) {
        // ensure options is an object, otherwise remove it
        if (!_.isObject(options)) {
          log.warn('options must be an object (will ignore)')
          options = null
        }
        options = options || {}

        // allow overriding type otherwise use default
        options.type = options.type || DEFAULT_TYPE

        // validate type
        var validType = _.includes(Types, options.type)
        if (!validType) {
          options.type = DEFAULT_TYPE
          log.warn('Invalid type specified (will use default)')
        }

        // get default options for type
        var typeOptions = getTypeOptions(options.type)
        // create our error from options, filling in the blanks with default options
        var error = _.defaults(options, typeOptions)

        // keep reference to current page
        error.stateName = $state.current.name
        error.stateParams = $state.params

        // store current error
        currentError = error

        // show the error page (dont update URL)
        $state.go(options.route, null, { location: false })
      }

      function getTypeOptions(type) {
        return _.clone(_.find(defaultTypeOptions, { type: type }))
      }

      /**
       * Get Error
       *
       * @desc returns the current error, or null if none
       */
      function get() {
        return _.clone(currentError)
      }

      function onStateChangeStart(trans) {
        var toState = trans.to()
        var goingToErrorPage = _.includes(Routes, toState.name)

        // routing away from error page clears current error
        if (!goingToErrorPage && currentError) {
          // log.info('cleared current error');
          currentError = null
        }

        // routing directly to error state is a big no-no!
        if (goingToErrorPage && !currentError) {
          log.info('tried to route to error page without an error')
          trans.abort()
        }
      }
    }
  }
})()
